// Module
var code = "<record-form-view fields=\"stateController.formFields\" model=\"stateController.progressiveControllerType\" title=\"Add Progressive Controller\" on-submit=\"stateController.submit(formViewController)\" on-cancel=\"stateController.cancel()\"> </record-form-view> ";
// Exports
export default code;